import { pipe } from 'fp-ts/function';
import { array, nonEmptyArray, record, string } from 'fp-ts';
import { useEnterprisesBusinessSegments } from '../../../../../../queries';
import { getEntitiesExternalIdentifiersIntersection, getExternalIdentifiersGroups } from '../../../../../../utilities';

interface UseCommonBusinessSegmentKeysParams {
    enterpriseIds: string[];
    serviceIds: string[];
}

export const useCommonBusinessSegmentKeys = ({ enterpriseIds, serviceIds }: UseCommonBusinessSegmentKeysParams) => {
    const { data: businessSegmentsResults, isFetching } = useEnterprisesBusinessSegments(enterpriseIds, serviceIds);
    const services = businessSegmentsResults?.services || [];
    const businessSegments = businessSegmentsResults?.businessSegments || [];

    if (services.length !== enterpriseIds.length || array.isEmpty(businessSegments)) {
        return {
            isFetching,
            data: [],
        };
    }
    const enterprisesByServiceId = pipe(
        services,
        nonEmptyArray.groupBy((service) => service.id),
        record.map((service) => service[0].enterpriseId)
    );

    const commonBusinessSegmentKeys = pipe(
        businessSegments,
        array.map((businessSegment) => ({
            ...businessSegment,
            enterpriseId: enterprisesByServiceId[businessSegment.serviceId],
        })),
        getExternalIdentifiersGroups,
        getEntitiesExternalIdentifiersIntersection,
        array.sort(string.Ord)
    );

    return {
        isFetching,
        data: commonBusinessSegmentKeys,
    };
};
